export const literals = {
  mercadoPago: {
    enabledPaymentMethodsLabel:
      'Select the payment methods your customers will be able to use within Mercado Pago:',
    guestModeLabel:
      'Select if you want your customers to have to log in to access Mercado Pago:',
    raddioButtonYes: 'Yes, they must be logged in.',
    raddioButtonNo: 'No, they do not have to log in.',
  },
}

export const mercadoPago = {
  mercadoPagoProMethod: 'MERCADO_PAGO_CHECKOUT_PRO',
  enabledPaymentMethods: [
    {
      value: 'atm',
      name: 'ATM',
    },
    {
      value: 'bank_transfer',
      name: 'Bank transfer',
    },
    {
      value: 'cash',
      name: 'Cash',
    },
    {
      value: 'credit_card',
      name: 'Credit card',
    },
    {
      value: 'debit_card',
      name: 'Debit card',
    },
    {
      value: 'mercado_pago',
      name: 'Mercado Pago',
    },
    {
      value: 'prepaid_card',
      name: 'Prepaid card',
    },
    {
      value: 'ticket',
      name: 'Tickets',
    },
  ],
  guestModeKeyParam: 'GUEST_MODE',
  enabledPaymentMethodsKeyParam: 'ENABLED_PAYMENT_METHODS',
  paymentMethodDisabled: 'mercado_pago',
}
